export async function getRejectRescuerDetails(productId, planId, prescriberId) {
    if (!productId || !planId || !prescriberId) {
        throw new Error('Missing required parameters');
    }

    const url = `${process.env.REACT_APP_API_URL}rejectRescuer/${encodeURIComponent(productId)}/${encodeURIComponent(planId)}/${encodeURIComponent(prescriberId)}`;
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (response.status === 200) {
        return await response.json();
    } else {
        throw response.statusText;
    }
}

